import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavBox from "./components/NavBox";
import "./css/index.css";
function Sidebar() {
  const navigate = useNavigate();
  const loaction = useLocation();
  const [isOpen, setIsOpen] = useState<number | undefined>(undefined);
  return (
    <aside
      className={`side-bar ${
        loaction.pathname.includes("write") || loaction.pathname.includes("fix")
          ? "blind"
          : ""
      }`}
    >
      {arr.map(({ category, img, nav }, idx) => {
        return img !== "/report" ? (
          <NavBox
            key={idx}
            category={category}
            img={img}
            nav={nav}
            path={loaction.pathname}
            setIsOpen={setIsOpen}
            isOpen={idx === isOpen}
            idx={idx}
          />
        ) : (
          <button
            className="nav-box"
            key={idx}
            onClick={() => {
              navigate("/report");
            }}
          >
            <div className="title-btn">
              <div className="left">
                <img src={`/assets/sidebar${img}.svg`} alt="" />
                <div className="title">{category}</div>
              </div>
            </div>
          </button>
        );
      })}
    </aside>
  );
}

export default Sidebar;

const arr = [
  {
    category: "회원 관리",
    img: "/user",
    nav: [
      {
        title: "팀플러 가입 목록",
        link: "/",
        type: "normal",
      },
      {
        title: "팀플리더 설정",
        link: "/leader",
        type: "normal",
      },
    ],
  },
  {
    category: "팀프로젝트 관리",
    img: "/project",
    nav: [
      {
        title: "임시저장 프로젝트",
        link: "/prjt/extra",
        type: "normal",
      },
      {
        title: "모집중 프로젝트",
        link: "/prjt/start",
        type: "normal",
      },
      {
        title: "모집마감 프로젝트",
        link: "/prjt/finish",
        type: "normal",
      },
      {
        title: "신규 프로젝트",
        link: "/prjt/write/step/1",
        type: "new",
      },
    ],
  },
  {
    category: "팀밋업 관리",
    img: "/meetup",
    nav: [
      {
        title: "임시저장 밋업",
        link: "/mtup/extra",
        type: "normal",
      },
      {
        title: "모집중 밋업",
        link: "/mtup/start",
        type: "normal",
      },
      {
        title: "모집마감 밋업",
        link: "/mtup/finish",
        type: "normal",
      },
      {
        title: "신규 밋업",
        link: "/mtup/write/step/1",
        type: "new",
      },
    ],
  },
  {
    category: "결제 관리",
    img: "/payment",
    nav: [
      {
        title: "프로젝트별 결제현황",
        link: "/payment",
        type: "normal",
      },
    ],
  },
  {
    category: "매거진 관리",
    img: "/magazine",
    nav: [
      {
        title: "매거진 리스트",
        link: "/magazine/list",
        type: "normal",
      },
      {
        title: "신규 매거진",
        link: "/magazine/write/step/1",
        type: "new",
      },
    ],
  },
  {
    category: "광고 관리",
    img: "/add",
    nav: [
      {
        title: "광고 리스트",
        link: "/add/list",
        type: "normal",
      },
    ],
  },
  {
    category: "기타 관리",
    img: "/etc",
    nav: [
      {
        title: "쿠폰 관리",
        link: "/etc/coupon",
        type: "normal",
      },
      {
        title: "공지사항 관리",
        link: "/etc/notice",
        type: "normal",
      },
      {
        title: "약관 관리",
        link: "/etc/policy",
        type: "normal",
      },
      {
        title: "인증서 관리",
        link: "/etc/certification",
        type: "normal",
      },
      {
        title: "팀플러 제휴 관리",
        link: "/etc/alliance",
        type: "normal",
      },
    ],
  },
  {
    category: "신고 관리",
    img: "/report",
    nav: [],
  },
];
